import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';

@Component({
    selector: 'new-fin-flujo',
    standalone: false,
    templateUrl: './new-fin-flujo.component.html',
    styleUrl: './new-fin-flujo.component.scss',
})
export class NewFinFlujoComponent implements OnInit {
  // Reactive Forms
  contactForm: FormGroup;

  constructor(private fb: FormBuilder, private router: Router) {
    // Initialize Contact Form
    this.contactForm = this.fb.group({
      nombre: ['', [Validators.required, Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/)]],
      celular: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      correo: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {
    // Component initialization logic if needed
  }

  enviarFormulario() {
    if (this.contactForm.valid) {
      const formValues = this.contactForm.value;
      console.log('Formulario enviado', {
        nombre: formValues.nombre,
        celular: formValues.celular,
        correo: formValues.correo
      });
      // Aquí puedes agregar la lógica para enviar los datos
    } else {
      console.log('Faltan campos obligatorios');
      this.contactForm.markAllAsTouched();
    }
  }

  // Form validation helper
  isValidField(field: string): boolean {
    const control = this.contactForm.get(field);
    return !!(control && control.errors && control.touched);
  }

  // Helper method to get label CSS classes based on field state
  getLabelClasses(field: string): string {
    const control = this.contactForm.get(field);
    if (!control || !control.touched) return ''; // No aplica clases si no ha sido tocado
    
    if (control.errors && control.touched) {
      return 'label-invalid';
    } else if (control.valid && control.touched) {
      return 'label-valid';
    }
    return '';
  }

  // Get specific field error message
  getFieldError(field: string): string {
    const control = this.contactForm.get(field);
    if (control && control.errors && control.touched) {
      if (control.errors['required']) return 'Asegúrate de llenar este campo';
      if (control.errors['email']) return "Asegúrate de incluir el símbolo '@'";
      if (control.errors['pattern']) {
        if (field === 'nombre') return 'Este campo debe contener únicamente letras';
        if (field === 'celular') return 'Asegúrate de ingresar un número válido de 10 dígitos';
      }
    }
    return '';
  }

  // Validation methods for backward compatibility (if needed)
  isNombreValid(): boolean {
    const control = this.contactForm.get('nombre');
    return control ? control.valid : false;
  }

  isCelularValid(): boolean {
    const control = this.contactForm.get('celular');
    return control ? control.valid : false;
  }

  isCorreoValid(): boolean {
    const control = this.contactForm.get('correo');
    return control ? control.valid : false;
  }
}